import { PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

// Weights are relative, they do not have to sum up to 100.
const PROVIDER_WEIGHTS = [
  { provider: PROVIDER.MESHY, weight: 80 },
  // Hunyuan stays listed at 0 so it never wins the roll while remaining available
  // to flows that pick a provider explicitly.
  { provider: PROVIDER.TENCENT, weight: 0 },
  { provider: PROVIDER.TRIPO3D, weight: 20 },
]

const TOTAL_WEIGHT = PROVIDER_WEIGHTS.reduce((sum, { weight }) => sum + weight, 0)

let rolledProvider

const rollProvider = () => {
  let threshold = Math.random() * TOTAL_WEIGHT

  const match = PROVIDER_WEIGHTS.find(({ weight }) => {
    threshold -= weight

    return threshold < 0
  })

  return (match || PROVIDER_WEIGHTS[0]).provider
}

/**
 * Resolves the model generation provider to activate when none is active yet,
 * using a weighted random roll performed once per page load. The roll is lazy so
 * it never runs during SSR - the first call comes from the useActiveModelSchema
 * effect. It is memoized so that a store reset (resetOpenedModelState) keeps the
 * engine assigned on load instead of re-rolling mid-session.
 *
 * @param {string[]} providers - Providers eligible for the current generation action.
 * @returns {string} The rolled provider, or the first eligible one when the
 *   rolled provider is not available for this action and settings combination.
 */
export const resolveInitialGenerationProvider = (providers) => {
  if (rolledProvider === undefined) {
    rolledProvider = rollProvider()
  }

  return providers.includes(rolledProvider) ? rolledProvider : providers[0]
}
